module.exports = __webpack_public_path__ + "static/penpad-5463cf3aabe41ba56ad79620d9fb3974.png";